import { supabase } from '@/lib/supabase';

export interface SavedSearch {
  id: string;
  user_id: string;
  name: string;
  filters: any;
  resultCount: number;
  lastUpdated: string;
}

export const savedSearchService = {
  async getSavedSearches() {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) return [];

    const { data, error } = await supabase
      .from('saved_searches')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching saved searches:', error);
      throw error;
    }

    return data.map((item: any) => ({
      id: item.id,
      user_id: item.user_id,
      name: item.name,
      filters: item.filters,
      resultCount: item.result_count,
      lastUpdated: new Date(item.created_at).toLocaleDateString()
    })) as SavedSearch[];
  },

  async createSavedSearch(name: string, filters: any, resultCount: number) {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('saved_searches')
      .insert({
        user_id: user.id,
        name,
        filters,
        result_count: resultCount
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating saved search:', error);
      throw error;
    }

    return {
      id: data.id,
      user_id: data.user_id,
      name: data.name,
      filters: data.filters,
      resultCount: data.result_count,
      lastUpdated: new Date(data.created_at).toLocaleDateString()
    } as SavedSearch;
  },

  async deleteSavedSearch(id: string) {
    const { error } = await supabase
      .from('saved_searches')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting saved search:', error);
      throw error;
    }

    return true;
  }
};
